exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plan-footer-one[data-v-64fa9277]{line-height:28px;height:28px}.open[data-v-64fa9277]{width:62px;height:32px;border:1px solid #dcdfe6;border-radius:4px;text-align:center;font-size:13px;color:#303133;line-height:32px;cursor:pointer}\n", ""]);

// exports
